<template>
  <section class="hero">
    <!-- Top Navigation -->
    <nav class="top-nav">
      <div class="nav-container">
        <div class="nav-left">
          <img src="https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250526105222_162.png" alt="至码云" class="logo" />
        </div>
        <div class="nav-right">
          <button class="btn-login" @click="goLogin">登录</button>
        </div>
      </div>
    </nav>

    <div class="hero-container">
      <!-- Main Content -->
      <div class="main-content">
        <h1 class="hero-title">
          海量模型优选<span class="gradient-text">至码引擎</span>
        </h1>
        
        <p class="hero-description">
          专业级大模型处理引擎。轻松接入接口，高速并发，快速回调。节约您百分之 50 以上的时间
        </p>

        <!-- Main Buttons -->
        <div class="main-buttons">
          <button class="btn-primary-large" @click="goLogin">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 19l7-7 3 3-7 7-3-3z"/>
              <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/>
              <path d="M2 2l7.586 7.586"/>
              <circle cx="11" cy="11" r="2"/>
            </svg>
            <span>立即登录</span>
          </button>
          
          <button class="btn-secondary-large" @click="goToApiDoc">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="16 18 22 12 16 6"/>
              <polyline points="8 6 2 12 8 18"/>
            </svg>
            <span>API 文档</span>
          </button>
        </div>
      </div>

      <!-- AI Model Icons -->
      <div class="model-icons">
        <div class="model-item" v-for="(model, index) in models" :key="index">
          <div class="model-icon-wrapper">
            <svg v-if="model.svg" viewBox="0 0 24 24" fill="currentColor" class="model-svg">
              <path :d="model.svg" />
            </svg>
            <img v-else :src="model.icon" :alt="model.name" class="model-icon" />
          </div>
          <div class="model-name">{{ model.name }}</div>
        </div>
      </div>

      <!-- Footer Copyright -->
      <div class="footer-copyright">
        <div class="copyright-text">
          <span>版权所有 © 至码云</span>
          <span class="divider">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">蜀 ICP 备 2023028033 号 -8</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  data() {
    return {
      models: [
        { 
          name: 'GPT-4', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/chatgtp.png'
        },
        { 
          name: 'Claude', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/claude.png'
        },
        { 
          name: 'Gemini', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/gemini-ai.png'
        },
        { 
          name: 'LLaMA', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/small-amazon.png'
        },
        { 
          name: '通义千问', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E9%80%9A%E4%B9%89%E5%8D%83%E9%97%AE.png'
        },
        { 
          name: '文心一言', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/AI_ERNIE%20Bot_%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD_%E6%96%87%E5%BF%83%E4%B8%80%E8%A8%80_%E7%99%BE%E5%BA%A6.png'
        },
        { 
          name: '豆包', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E8%B1%86%E5%8C%85%20%282%29.png'
        },
        { 
          name: '即梦', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E5%8D%B3%E6%A2%A6AI.png'
        },
        { 
          name: 'Kimi', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/AI_Kimi_%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD.png'
        },
        { 
          name: '至码云', 
          icon: 'https://zhimayun0023.oss-cn-beijing.aliyuncs.com/ai%20%281%29.png'
        }
      ]
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    goToApiDoc() {
      window.open('https://s.apifox.cn/99d32eb0-7b13-4b37-a95e-42d925207c46?pwd=123456', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Top Navigation */
.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 16px 0;
  background: transparent;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-left {
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  width: auto;
  object-fit: contain;
  border-radius: 8px;
}

.nav-right {
  display: flex;
  align-items: center;
}

.btn-login {
  padding: 10px 24px;
  background: #0f172a;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(15, 23, 42, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.hero-container {
  flex: 1;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 100px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Main Content */
.main-content {
  text-align: center;
  max-width: 800px;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.hero-title {
  font-size: 64px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin-bottom: 24px;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

.gradient-text {
  display: block;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #d946ef 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-description {
  font-size: 18px;
  line-height: 1.7;
  color: #64748b;
  margin-bottom: 48px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

/* Action Cards */
.action-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.action-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 
    0 4px 16px rgba(0, 0, 0, 0.04),
    inset 0 1px 1px rgba(255, 255, 255, 0.95);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 8px 24px rgba(0, 0, 0, 0.06),
      inset 0 1px 1px rgba(255, 255, 255, 0.95);
  }
}

.card-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  flex-shrink: 0;
  
  &.purple {
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    color: #6366f1;
  }
  
  &.pink {
    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
    color: #ec4899;
  }
}

.card-content {
  text-align: left;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 4px;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

.card-desc {
  font-size: 13px;
  color: #64748b;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

/* Main Buttons */
.main-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary-large {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  background: #0f172a;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 4px 12px rgba(15, 23, 42, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 8px 20px rgba(15, 23, 42, 0.4),
      inset 0 1px 1px rgba(255, 255, 255, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.btn-secondary-large {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  background: rgba(255, 255, 255, 0.9);
  color: #0f172a;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 1px rgba(255, 255, 255, 0.9);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
  
  &:hover {
    background: white;
    transform: translateY(-2px);
    box-shadow: 
      0 4px 12px rgba(0, 0, 0, 0.06),
      inset 0 1px 1px rgba(255, 255, 255, 0.95);
  }
  
  &:active {
    transform: translateY(0);
  }
}

/* Model Icons */
.model-icons {
  margin-top: 80px;
  display: flex;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
  animation: fadeInUp 1s ease-out 0.6s both;
}

.model-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-4px);
  }
  
  &:nth-child(1) .model-svg {
    color: #10a37f;
  }
  
  &:nth-child(2) .model-svg {
    color: #d97757;
  }
  
  &:nth-child(3) .model-svg {
    color: #4285f4;
  }
  
  &:nth-child(4) .model-svg {
    color: #0668e1;
  }
  
  &:nth-child(5) .model-svg {
    color: #615ced;
  }
  
  &:nth-child(6) .model-svg {
    color: #2962ff;
  }
}

.model-icon-wrapper {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 
    0 4px 16px rgba(0, 0, 0, 0.04),
    inset 0 1px 1px rgba(255, 255, 255, 0.95);
  padding: 12px;
}

.model-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.model-svg {
  width: 100%;
  height: 100%;
}

.model-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

/* Footer Copyright */
.footer-copyright {
  margin-top: auto;
  padding: 20px 0;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.copyright-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 13px;
  color: #0f172a;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", sans-serif;
}

.divider {
  color: #cbd5e1;
}

.icp-link {
  color: #0f172a;
  text-decoration: none;
  transition: all 0.2s ease;
  
  &:hover {
    color: #1e293b;
    text-decoration: underline;
  }
}

/* Animations */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 42px;
  }
  
  .hero-description {
    font-size: 16px;
  }
  
  .action-cards {
    grid-template-columns: 1fr;
  }
  
  .main-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .model-icons {
    gap: 24px;
  }
  
  .nav-container {
    padding: 0 16px;
  }
  
  .logo {
    height: 36px;
  }
}
</style>
